import { t } from "i18next";

export const SUPPORTED_LANGUAGES = ["en", "fi"] as const;

type SupportedLanguageTuple = typeof SUPPORTED_LANGUAGES;
export type SupportedLanguage = SupportedLanguageTuple[number];

export const isSupportedLanguage = (lang: string | undefined): lang is SupportedLanguage => {
	return lang !== undefined ? SUPPORTED_LANGUAGES.includes(lang as any) : false;
};

export const getSupportedLanguageLabels = () => ({
	fi: t("finnish"),
	en: t("english"),
});

export const getSupportedLanguageLabel = (value: SupportedLanguage): string => {
	return getSupportedLanguageLabels()[value];
};
